<template>
  <hooper :settings="hooperSettingsMain">
    <slide>
      <img v-if='window.width > 700' src='@/assets/main-slide-1.jpeg'>
      <img v-else src='@/assets/main-slide-mobile-1.jpeg'>
    </slide>
    <slide>
      <img v-if='window.width > 700' src='@/assets/main-slide-2.jpeg'>
      <img v-else src='@/assets/main-slide-mobile-2.jpeg'>
    </slide>
    <slide>
      <img v-if='window.width > 700' src='@/assets/main-slide-3.jpeg'>
      <img v-else src='@/assets/main-slide-mobile-3.jpeg'>
    </slide>
    <slide>
      <img v-if='window.width > 700' src='@/assets/main-slide-4.jpeg'>
      <img v-else src='@/assets/main-slide-mobile-4.jpeg'>
    </slide>
    <hooper-pagination slot='hooper-addons'></hooper-pagination>
  </hooper>
</template>
<script>
  import { Hooper, Slide, Pagination as HooperPagination} from 'hooper';
  import 'hooper/dist/hooper.css';

  export default {
    props: ['window'],
    components: {
      Hooper,
      Slide,
      HooperPagination,
    },
    data() {
      return {
        hooperSettingsMain: {
          wheelControl: false,
          autoPlay: true,
          PlaySpeed: 2000,
          itemsToShow: 1,
          infiniteScroll: true,
          vertical: false,
        }
      }
    }
  }
</script>

<style scoped>
  .hooper{
    height: auto !important;
  }
  .hooper img{
    width: 100%;
  }

</style>
